/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Ai_Mode_LightingInputs */

const cs_property_ai_mode_lighting = /** @type {(inputs: Property_Ai_Mode_LightingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Osvětlení`)
};

const en_property_ai_mode_lighting = /** @type {(inputs: Property_Ai_Mode_LightingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lighting`)
};

/**
* | output |
* | --- |
* | "Lighting" |
*
* @param {Property_Ai_Mode_LightingInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_ai_mode_lighting = /** @type {((inputs?: Property_Ai_Mode_LightingInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Ai_Mode_LightingInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_ai_mode_lighting(inputs)
	return cs_property_ai_mode_lighting(inputs)
});